import Selectors from './selectors';
import * as Actions from './actions';
import { transformIn } from './api';
import { COLORS, GEOFENCE_NAME_MAX_LENGTH } from './constants';

export default {
    Selectors,
    Actions,
    COLORS,
    GEOFENCE_NAME_MAX_LENGTH,
    unpack: transformIn,
};
